import api from '@/http';
import { clearUserSession, scheduleSessionExpiry } from './session';
export { currentUser } from './session';

const cookieBackedSessionId = '00000000-0000-0000-0000-000000000000';

export function storeUserSession(user) {
  const roles = user.roles || [];
  const userSession = {
    sessionId: cookieBackedSessionId,
    userId: user.userId,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    status: user.status,
    roles,
    expiresAt: user.expiresAt,
  };

  localStorage.removeItem('rassplSessionId');
  localStorage.setItem('rassplUser', JSON.stringify(userSession));
  scheduleSessionExpiry();
}

export function currentSessionId() {
  return '';
}

export async function logoutUser() {
  try {
    await api.post('rasspl/api/logout');
  } finally {
    clearUserSession();
  }
}
